import React, { useState } from 'react'
import { Modal, Button, TextField } from '@ui'
import { createOrg } from '../api.js'

// Matches the backend regex and the Cognito custom:org length constraint.
const SLUG_RE = /^[a-z0-9-]{3,10}$/

export function CreateOrgModal({ onClose, onCreated }) {
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')
  const [maxUsers, setMaxUsers] = useState(50)
  const [adminEmail, setAdminEmail] = useState('')
  const [adminName, setAdminName] = useState('')
  const [err, setErr] = useState(null)
  const [busy, setBusy] = useState(false)

  const slugValid = SLUG_RE.test(slug)
  const canSubmit = name.trim() && slugValid && maxUsers >= 1 && /.+@.+\..+/.test(adminEmail)

  async function submit(e) {
    e.preventDefault()
    if (!canSubmit) return
    setBusy(true); setErr(null)
    try {
      const t = await createOrg({
        name: name.trim(),
        slug,
        maxUsers: Number(maxUsers),
        adminEmail,
        adminName: adminName.trim() || null,
      })
      onCreated(t.orgId)
    } catch (e) {
      if (e.code === 'SLUG_TAKEN') setErr('That slug is already taken.')
      else setErr(e.message || 'Failed to create org.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Modal open onClose={onClose} title="Create org">
      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <label>Organisation name
          <TextField value={name} onChange={(e) => setName(e.target.value)} required maxLength={120} />
        </label>
        <label>Subdomain slug
          <TextField
            value={slug}
            onChange={(e) => setSlug(e.target.value.toLowerCase())}
            required
            placeholder="acme"
            aria-invalid={slug && !slugValid}
          />
          <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>
            {slug ? `${slug}.soundcheck11.com` : 'Lowercase letters, digits, dashes; 3–10 chars.'}
          </div>
          {slug && !slugValid && (
            <div style={{ color: 'var(--danger-text)', fontSize: 12 }}>
              Invalid format. Use lowercase letters, digits, or dashes (3–10 chars).
            </div>
          )}
        </label>
        <label>Max users
          <TextField
            type="number"
            value={maxUsers}
            onChange={(e) => setMaxUsers(e.target.value)}
            min={1}
            max={10000}
            required
          />
        </label>
        <label>First admin email
          <TextField type="email" value={adminEmail} onChange={(e) => setAdminEmail(e.target.value)} required />
        </label>
        <label>First admin name (optional)
          <TextField
            value={adminName}
            onChange={(e) => setAdminName(e.target.value)}
            placeholder="Defaults to the email local part"
            maxLength={120}
          />
        </label>
        {err && <div style={{ color: 'var(--danger-text)' }}>{err}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
          <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={!canSubmit || busy}>
            {busy ? 'Creating…' : 'Create + send invite'}
          </Button>
        </div>
      </form>
    </Modal>
  )
}
